import { defineComponent as _defineComponent } from 'vue'
import { useStore } from '@nuxtjs/composition-api';
import { computed, onUnmounted } from 'vue';
import NftPromotion from '~/components/Promotions/NftPromotion.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectNftPromotion',
  setup(__props) {

const { state, dispatch } = useStore();

const show = computed(() => state?.projects?.nftPromotionsState?.show ?? false);

const promotion = computed(
  () => state?.projects?.nftPromotionsState?.promotion,
);

function close() {
  dispatch('projects/hideProjectNftPromotion');
}

onUnmounted(() => close());

return { __sfc: true,state, dispatch, show, promotion, close, NftPromotion }
}

})